import api from "@/common/js/api";

import { h } from "vue";

import { getUrlParams } from "@/common/js/utils";
import { ElMessage, ElMessageBox } from "element-plus";
import { tenderProjectConfig } from "@store/tender/modules/waterStore";
let state = {
  params: {},
  registrationUrl: null,
};
const signConfig = {
  water: {
    signJsonUrl: "/static/config/openSignConfigWater.json",
  },
  house: {
    signJsonUrl: "/static/config/openSignConfig.json",
  },
};

const getOpenSignConfig = () => {
  return new Promise((resolve, reject) => {
    api.get(signConfig[__type__ || "house"].signJsonUrl).then((res) => {
      resolve(res);
    });
  });
};
const getAreaTree = (state) => {
  return new Promise((resolve, reject) => {
    api.get("/TenderFlow/GetAreaTree").then((res) => {
      if (res.result) {
        resolve(res.json);
      } else {
        reject(res.msg);
      }
    });
  });
};
const getTenderProject = ($store) => {
  return new Promise((resolve, reject) => {
    let url = __type__ == "water" ? "/TenderProject/Get_Creator" : "/TenderProject/Get";
    api.get(url, {
      tpId: state.params.foId,
    }).then((res) => {
      if (res.result) {
        const { json } = res
        $store.commit('houseStore/setIsEnableGeneralPurchaseJump', json.isEnable_general_purchase_jump)
        resolve(json);
      } else {
        ElMessageBox.alert(res.msg, "提示", {
          type: "error",
        });
        $store.commit("setLoading", false);
      }
    });
  });
};

const getActions = () => {
  return new Promise((resolve, reject) => {
    api
      .get("/TenderFlow/GetAction", {
        idTime: Date.now(),
        flowId: state.params.flowId,
        actionId: state.params.actionId,
      })
      .then((res) => {
        if (res.result) {
          resolve([res.json]);
        } else {
          reject(res.msg);
        }
      });
  });
};

const getNextActions = (tag) => {
  return new Promise((resolve, reject) => {
    api
      .get("/TenderFlow/GetNextActions", {
        flowId: state.params.flowId,
        foId: state.params.foId,
        tag,
      })
      .then((res) => {
        if (res.result) {
          resolve(res.json);
        } else {
          reject(res.msg);
        }
      });
  });
};

const getPublicActions = (form, isHasGuarantee, statusList = []) => {
  return new Promise((resolve, reject) => {
    let actions = [];
    let dzbhAction = {
      actionName: "电子保函申请",
      available: true,
      actionContent: {
        type: "view",
        openPage: true,
        pageUrl: `/TenderProject/Redirect?foId=${state.params.foId}`,
      },
    };
    let hqbsAction = {
      actionName: "获取标书",
      available: true,
      actionContent: {
        type: "view",
        openPage: true,
        pageUrl: `/views/ebid/tenderSale/v1/purchase.html?actionId=getBidderDoc&foId=${state.params.foId}&flag=true&name=`,
      },
    };
    let marginAction = {
      actionName: "查询保证金",
      available: true,
      actionContent: {
        type: "view",
        openPage: true,
        pageUrl: `/Margin/QueryPage`,
      },
    };
    let accountAction = {
      actionName: "获取子账号",
      available: true,
      actionContent: {
        type: "view",
        openPage: true,
        pageUrl: `/Margin/GetAccount?foId=${state.params.foId}`,
      },
    };
    let zyAction = {
      actionName: "质疑",
      available: true,
      actionContent: {
        type: "view",
        openPage: true,
        pageUrl: `/TenderProject/Jump?url=${`/views/ebid/tenderQuestion/v2/bidder.html?foId=${state.params.foId}`}`,
      },
    };
    if (isHasGuarantee) {
      actions.push(dzbhAction);
    }
    if (location.search.indexOf("&flag=false") === -1) {
      actions.push(hqbsAction);
      if (form.isBondOnline) {
        actions.push(marginAction);
        // 排除已终止状态下获取子账号
        if (statusList.indexOf('stoped') === -1) {
          actions.push(accountAction);
        }
      }
    }
    if (form.way !== '邀请招标') actions.push(zyAction)

    resolve(actions);
  });
};

const getRecords = (url) => {
  url = url.replace(/^[^?]+/, "");
  if (__type__ == "water") {
    return new Promise((resolve, reject) => {
      api.post("/TenderFlow/RecordsN", {}, getUrlParams(url)).then((res) => {
        if (res.result) {
          resolve(res.json);
        } else {
          reject(res.msg);
        }
      });
    });
  } else {
    return new Promise((resolve, reject) => {
      api.get("/TenderFlow/Records", getUrlParams(url)).then((res) => {
        if (res.result) {
          resolve(res.json);
        } else {
          reject(res.msg);
        }
      });
    });
  }
};

const getDataExchange = () => {
  return new Promise((resolve, reject) => {
    api.get("/Signture/GetDataExchange", state.params).then((res) => {
      if (res.result) {
        resolve(res.json);
      } else {
        reject(res.msg);
      }
    });
  });
};

const setEntpBaseInfo = (form, $vm) => {
  api
    .get("/User/UserApiUUM", {
      api: "getUnitBaseInfo",
    })
    .then((res) => {
      if (res.result) {
        form.UUM_ENTP_BASE_INFO = res.json;
      } else {
        ElMessageBox({
          title: "信息不完整提示",
          type: "error",
          message: h("p", null, [
            h("span", null, "请先到"),
            h(
              "span",
              {
                style: "color: red",
                attrs: {
                  href: "/User/Jump2UUM?operate=epInfo&type=hc",
                  target: "_parent",
                },
              },
              "信息申报"
            ),
            h("span", null, "中填写完整的企业基本信息并提交"),
          ]),
          closeOnClickModal: false,
          showCancelButton: true,
          confirmButtonText: "已了解",
          beforeClose: (e) => {
            window.open("/User/Jump2UUM?operate=epInfo", "_parent");
          },
        })
          .then((e) => null)
          .catch((e) => null);
      }
    });
};

const getAlipayAccounts = () => {
  return new Promise((resolve, reject) => {
    api.get("/User/UserApiUUM?api=alipayAccount", {}).then((res) => {
      if (res.result) {
        resolve(res.json);
      } else {
        reject();
      }
    });
  });
};
const getBankList = (form) => {
  let val = "";
  if (form.TRADE_CENTER) {
    val = form.TRADE_CENTER.Value;
  } else {
    val = form.regionId;
  }
  return new Promise((resolve, reject) => {
    if (val) {
      api.get("/MarginPlugin/BANK_LIST", { CENTERCODE: val }).then((res) => {
        if (res.DATA) {
          resolve(res.DATA);
        } else {
          reject();
        }
      });
    } else {
      // reject();
    }
  });
};
const getBookingOptions_old = (form) => {
  return new Promise((resolve, reject) => {
    api.get("/static/config/siteBookingServelUrl.json").then((response) => {
      let host = response.siteBookingServelUrl;
      let arr = [
        { regionId: "x60005", siteId: response.fgSiteId },
        { regionId: "x60006", siteId: response.yxSiteId },
      ];
      let result = [{ EnumValue: "1", Value: "其他场地", Name: "其他场地" }];
      if (form.regionId === "x60005") {
        if (/(localhost|test)/.test(location.hostname)) {
          resolve([
            {
              EnumValue: "45c2ff13-587f-4d94-be07-456572174034",
              Value: "随行易交易（福清）公共资源交易平台",
              Name: "随行易交易（福清）公共资源交易平台",
            },
          ]);
        } else {
          resolve([
            { EnumValue: "03228a9a-d257-4c2d-bccb-3b0d821eaeb7", Value: "易交易（福清）公共资源交易平台", Name: "易交易（福清）公共资源交易平台" },
          ]);
        }
      } else if (form.regionId === "x60010") {
        if (/(localhost|test)/.test(location.hostname)) {
          resolve([
            {
              EnumValue: "df7b9fc6-09fe-4e54-9ffa-adfa9c9f90a2",
              Value: "随行易交易（龙岩）公共资源交易平台",
              Name: "随行易交易（龙岩）公共资源交易平台",
            },
          ]);
        } else {
          resolve([
            {
              EnumValue: "bd4ee2a0-6234-4aaa-bf6a-769a0309db2d",
              Value: "随行易交易（龙岩）公共资源交易平台",
              Name: "随行易交易（龙岩）公共资源交易平台",
            },
          ]);
        }
      } else {
        // if (process.env.NODE_ENV === 'development') return false
        api
          .get(host + "/Api/v1/Center/GetCentInfoList", {
            Page: 1,
            PageCount: 999,
          })
          .then((res) => {
            if (res.status == 0) {
              res.list.forEach((item) => {
                result.push({
                  EnumValue: item.id,
                  Value: item.name,
                  Name: item.name,
                });
              });

              arr.forEach((obj) => {
                if (form.regionId == obj.regionId) {
                  res.list.forEach((item) => {
                    if (item.id == obj.siteId) {
                      result = [{ EnumValue: item.id, Value: item.name, Name: item.name }];
                      /*尤溪可选其他场地*/
                      if (obj.regionId == "x60006") {
                        result = [
                          { EnumValue: "1", Value: "其他场地", Name: "其他场地" },
                          { EnumValue: item.id, Value: item.name, Name: item.name },
                        ];
                      }
                    }
                  });
                  if (form.regionId == "x60005") {
                    form["OPEN_BID_SITE"] = obj.siteId;
                  }
                  if (form.regionId == "x60010") {
                    form["OPEN_BID_SITE"] = obj.siteId;
                  }
                } else {
                  res.list.forEach((item, index) => {
                    if (item.id == obj.siteId) {
                      result.splice(index + 1, 1);
                    }
                  });
                }
              });

              resolve(result);
            } else {
              reject();
            }
          })
          .catch((e) => null);
      }
    });
  });
};

/**
 * 获取场地选项
 * {
 *   "siteBookingServelUrl": "https://cdyuyuetest.enjoy5191.com:15064",
 *   "x60005": "45c2ff13-587f-4d94-be07-456572174034",
 *   "x60010": "df7b9fc6-09fe-4e54-9ffa-adfa9c9f90a2",
 *   "withElse": [ "x60006" ]
 * }
 */
const getBookingOptions = (form) => {
  return new Promise((resolve, reject) => {
    api.get("/static/config/siteBookingServelUrl.json").then((res1) => {
      const { siteBookingServelUrl: host, withElse = [] } = res1;
      api
        .get(`${host}/Api/v1/Center/GetCentInfoList`, {
          Page: 1,
          PageCount: 999,
        })
        .then((res2) => {
          if (res2.status === 0) {
            const siteBookingId = res1[form.regionId];
            const elseSite = { EnumValue: "1", Value: "其他场地", Name: "其他场地" };
            const list = res2.list.map(({ id, name }) => ({
              EnumValue: id,
              Value: name,
              Name: name,
            }));
            if (siteBookingId) {
              const [regionSite] = list.filter((obj) => obj.EnumValue === siteBookingId);
              if (withElse.indexOf(form.regionId) >= 0) {
                resolve([regionSite, elseSite]);
              } else {
                form.OPEN_BID_SITE = regionSite.EnumValue;
                resolve([regionSite]);
              }
            } else {
              resolve([...list, elseSite]);
            }
          } else {
            reject();
          }
        })
        .catch((e) => null);
    });
  });
};

const getRegistionUrl = () => {
  return new Promise((resolve, reject) => {
    if (state.registrationUrl) {
      resolve(state.registrationUrl);
    } else {
      api.get("/static/config/registrationConfig.json").then((res) => {
        state.registrationUrl = res.registrationUrl;
        resolve(state.registrationUrl);
      });
    }
  });
};

const getSections = (param) => {
  return new Promise((resolve, reject) => {
    getRegistionUrl().then((url) => {
      api.get(`${url}/xjyjs/api/getData`, param).then((res) => {
        if (res.code === "200") {
          resolve(res.data);
        }
      });
    });
  });
};

const getRegSectionDetail = (param) => {
  return new Promise((resolve, reject) => {
    getRegistionUrl().then((url) => {
      api.get(`${url}/xjyjs/api/getDataInfoByTenderProjectCode`, param).then((res) => {
        if (res.code === 0) {
          resolve(res.data);
        }
      });
    });
  });
};

const getBaOrBjData = (url, form, code, name) => {
  return new Promise((resolve, reject) => {
    api
      .get(`/proxy/bj?url=${url}`, {
        regionCode: form.regionId,
        code: code,
      })
      .then((res) => {
        if (res.Code === 0) {
          resolve(res.Result);
        } else {
          ElMessageBox.alert(`${res.ErrorDesc}，请确认${name}`, "提示", {
            type: "error",
          });
        }
      });
  });
};

const doSwitch = (obj, form, $store) => {
  let { commit } = $store;
  let { actionContent } = obj;
  switch (actionContent.type) {
    case "commit":
      if (__type__ == "water") {
        doCommitWater($store, obj, form, () => {
          ElMessage.success(`${obj.actionName}成功`);
          commit("setReloadActions");
        });
      } else {
        doCommit($store, obj, form, () => {
          ElMessage.success(`${obj.actionName}成功`);
          commit("setReloadActions");
        });
      }

      break;
    case "sign":
      if (__type__ == "water") {
        doSignWater($store, obj, form);
      } else {
        doSign($store, obj, form);
      }

      break;
    case "form":
      doForm($store, obj, form, () => {
        ElMessage.success(`${obj.actionName}成功`);
        commit("setReloadActions");
      });
      break;
    default:
      break;
  }
};
const doCommitWater = ($store, obj, form, call) => {
  let { url } = obj.actionContent;
  let { $vm, config, electronicMail } = $store.state;
  let electronic_this = electronicMail.$vm;

  if (!form.PROJECT_NAME) {
    $vm.scrollToFormItem();
    return ElMessageBox.alert("请填写项目名称", "操作提示", {
      type: "error",
    });
  }
  if (!form.TENDER_PROJECT_NAME) {
    // $vm.scrollToFormItem();
    return ElMessageBox.alert("请填写招标项目名称", "操作提示", {
      type: "error",
    });
  }
  form.updateContent_price = config.Prices.reduce((pre, cur) => {
    pre[cur] = form[cur];
    return pre;
  }, {});
  form.updateContent_cost = {
    TENDER_QUANTITIES: {},
  };
  form.updateContent_cost.TENDER_QUANTITIES = config.Cost.reduce((pre, cur) => {
    pre[cur] = form[cur];
    return pre;
  }, {});
  if (form.type == "勘察设计") {
    form.NOTICE_MEDIA4 = form.NOTICE_MEDIA3;
    form.PM_TABLE_DATA.forEach((item) => {
      item.POSTNAME = "项目人员";
    });
  }
  // form.BID_OPEN_TIME='2025-02-29 10:00:00'
  delete form.TENDER_CODE;
  delete form.TENDER_SCHEDULE;
  delete form.updateContent_time;
  delete form.InviteEnterprises;
  delete form.updateContent_InviteEnterprises;

  let data = JSON.parse(JSON.stringify(tenderProjectConfig.CACL_KEY_FUNC(form.type, form)));
  /* 工程建设那边显示不需要BID_OPEN_TIME */
  delete data.BID_OPEN_TIME;
  console.log(data);
  $store.commit("setLoading", true);
  api
    .post(url, JSON.stringify(data))
    .then((res) => {
      $store.commit("setLoading", false);
      if ($store.state.modules.electronicMail) {
        electronic_this.commit(() => {
          if (res.result) {
            if (state.params.foId) {
              call && call();
            } else {
              location.search = `?foId=${res.json.FoId.$oid}&flowId=${state.params.flowId}`;
            }
          } else {
            ElMessageBox.alert(res.msg, "操作提示", {
              type: "error",
            });
          }
        });
      } else {
        if (res.result) {
          if (state.params.foId) {
            call && call();
          } else {
            location.search = `?foId=${res.json.FoId.$oid}&flowId=${state.params.flowId}`;
          }
        } else {
          ElMessageBox.alert(res.msg, "操作提示", {
            type: "error",
          });
        }
      }
    })
    .catch((e) => {
      $store.commit("setLoading", false);
    });
};

const doCommit = ($store, obj, form, call) => {
  let { url } = obj.actionContent;
  let { $vm, config, electronicMail } = $store.state;
  let electronic_this = electronicMail.$vm;

  if (config.WithRegistion && !form.REGISTRATION) {
    return ElMessageBox.alert("请选择入场登记", "操作提示", {
      type: "error",
    });
  }

  if (!form.TENDER_PROJECT_NAME) {
    $vm.scrollToFormItem(undefined, undefined, "error-level-8");
    return ElMessageBox.alert("请填写招标项目名称", "操作提示", {
      type: "error",
    });
  }

  if (!form.PROJECT_NAME) {
    $vm.scrollToFormItem(undefined, undefined, "error-level-9");
    return ElMessageBox.alert("请填写项目名称", "操作提示", {
      type: "error",
    });
  }

  form.updateContent_price = config.Prices.reduce((pre, cur) => {
    pre[cur] = form[cur];
    return pre;
  }, {});

  form.TRADE_CENTER = {
    Name: form.region,
    Value: form.regionId,
  };
  form.TENDER_MODE = form.way;
  form.TRADE_CENTER_SELECT = form.region;
  form.IS_OPEN_INVITATION = form.IS_OPEN !== "不公开";
  form.IsVue3Doc = true;

  // form.IS_REPORT_PROVINCE = false

  // if(form.type === '工程总承包') {
  //   console.log('🍖🍖', form)
  //   return false
  // }

  $store.commit("setLoading", true);
  api
    .post(url, JSON.stringify(form))
    .then((res) => {
      $store.commit("setLoading", false);
      if ($store.state.modules.electronicMail) {
        electronic_this.commit(() => {
          if (res.result) {
            if (state.params.foId) {
              call && call();
            } else {
              location.search = `?foId=${res.json.FoId.$oid}&flowId=${state.params.flowId}`;
            }
          } else {
            ElMessageBox.alert(res.msg, "操作提示", {
              type: "error",
            });
          }
        });
      } else {
        if (res.result) {
          if (state.params.foId) {
            call && call();
          } else {
            location.search = `?foId=${res.json.FoId.$oid}&flowId=${state.params.flowId}`;
          }
        } else {
          ElMessageBox.alert(res.msg, "操作提示", {
            type: "error",
          });
        }
      }
    })
    .catch((e) => {
      $store.commit("setLoading", false);
    });
};
const doForm = ($store, obj, form, call) => {
  let { url } = obj.actionContent;
  $store.commit("setLoading", true);
  api.post(url, {}).then((res) => {
    $store.commit("setLoading", false);
    call && call();
  });
};
const doSignWater = ($store, obj, form) => {
  let { commitAction, $vm, electronicMail, reportToCTBA } = $store.state;
  let electronic_this = electronicMail.$vm;
  let ctba_this = reportToCTBA.$vm;

  let { commit } = $store;
  let { url } = obj.actionContent;
  commitOrNot($store, commitAction, form, () => {
    $vm.validate(
      () => {
        ctba_this.validForm((v) => {
          if (v) {
            electronic_this.validForm((valid) => {
              if (valid) {
                electronic_this.sign(() => {
                  electronic_this.signMail(form, () => {
                    $store.commit("setLoading", true);
                    /* 提示 */
                    if (form.regionId == "x60004") {
                      api
                        .post(url, JSON.stringify(form))
                        .then((res) => {
                          $store.commit("setLoading", false);
                          if (res.result) {
                            commit("setSignUrlOptions", res);
                          } else {
                            ElMessageBox.alert(res.msg, "操作提示", {
                              type: "error",
                            });
                          }
                        })
                        .catch((e) => {
                          $store.commit("setLoading", false);
                        });
                    } else {
                      let signTip = [
                        h("p", null, [h("span", null, "是否在省监督平台报建及备案："), h("span", { style: "color: teal" }, form.isReport)]),
                      ];
                      if (form.IS_REPORT) {
                        signTip.push(h("p", null, [h("span", null, "报建编号："), h("span", { style: "color: teal" }, form.REPORT_NUMBER)]));
                        signTip.push(h("p", null, [h("span", null, "备案编号："), h("span", { style: "color: teal" }, form.RECORD_NUMBER)]));
                      }
                      if (form.regionId.indexOf("x") !== 0) {
                        signTip.push(
                          h("p", null, [h("span", null, "是否报送省公共服务平台："), h("span", { style: "color: teal" }, form.isReportProvince)])
                        );
                      }
                      ElMessageBox.confirm(h("div", null, signTip), obj.actionName, {
                        type: "warning",
                      })
                        .then((actions) => {
                          api
                            .post(url, JSON.stringify(form))
                            .then((res) => {
                              $store.commit("setLoading", false);
                              if (res.result) {
                                commit("setSignUrlOptions", res);
                              } else {
                                ElMessageBox.alert(res.msg, "操作提示", {
                                  type: "error",
                                });
                              }
                            })
                            .catch((e) => {
                              $store.commit("setLoading", false);
                            });
                        })
                        .catch((e) => {
                          $store.commit("setLoading", false);
                        });
                    }
                  });
                });
              } else {
                ElMessageBox.alert("请填写完所有电子保函补充信息", "操作提示", {
                  type: "error",
                }).then(() => {
                  electronic_this.scrollIntoView();
                });
              }
            });
          } else {
            ElMessageBox.alert("请选择是否上报省平台", "操作提示", {
              type: "error",
            }).then(() => {
              ctba_this.scrollIntoView();
            });
          }
        });
      },
      (e) => {
        console.log("validate", e);
        ElMessageBox.alert("请填写完所有必填项", "操作提示", {
          type: "error",
        });
        $vm.scrollToFormItem();
      }
    );
  });
};
const doSign = ($store, obj, form) => {
  let { commitAction, $vm } = $store.state;
  let { commit } = $store;
  let { url } = obj.actionContent;

  commitOrNot($store, commitAction, form, () => {
    validFormOrNot($store, () => {
      validByX($store, form, () => {
        $store.commit("setLoading", true);
        api
          .post(url, JSON.stringify(form))
          .then((res) => {
            $store.commit("setLoading", false);
            if (res.result) {
              commit("setSignUrlOptions", res);
            } else {
              ElMessageBox.alert(res.msg, "操作提示", {
                type: "error",
              });
            }
          })
          .catch((e) => {
            $store.commit("setLoading", false);
          });
      });
    });
  });
};

const validFormOrNot = ($store, call) => {
  let { $vm, isEdit } = $store.state;
  if (isEdit) {
    $vm.validate(call, (e) => {
      console.log("validate", e);
      ElMessageBox.alert("请填写完所有必填项", "操作提示", {
        customClass: "ctba-message-info",
        type: "info",
      });
      $vm.scrollToFormItem();
    });
  } else {
    call && call();
  }
};

const validByX = ($store, form, call) => {
  let { electronicMail, reportToCTBA } = $store.state;
  let electronic_this = electronicMail.$vm;
  let ctba_this = reportToCTBA.$vm;
  if (ctba_this) {
    ctba_this.validForm((v, invalidFields) => {
      if (v) {
        electronic_this.validForm((valid, invalidFields) => {
          if (valid) {
            electronic_this.signMail(form, () => {
              validBjOrBa(form, () => {
                call();
              });
            });
          } else {
            ElMessageBox.alert("请填写完所有电子保函补充信息", "操作提示", {
              customClass: "ctba-message-info",
              type: "info",
            }).then(() => {
              electronic_this.scrollIntoView();
            });
          }
        });
      } else {
        let validMsg = "请点击推送签章按钮，并完成推送签章。";
        if (invalidFields.IS_REPORT_CTBA) {
          validMsg = "请选择是否推送到公共服务平台（国家）。";
        }
        ElMessageBox.alert(validMsg, "操作提示", {
          customClass: "ctba-message-info",
          type: "info",
        }).then(() => {
          ctba_this.scrollIntoView();
        });
      }
    });
  } else {
    call();
  }
};

const validBjOrBa = (form, call) => {
  let message = [h("p", null, [h("span", null, "是否在省监督平台备案："), h("span", { style: "color: teal" }, form.select_IS_REPORT)])];
  if (form.IS_REPORT) {
    message.push(h("p", null, [h("span", null, "报建编号："), h("span", { style: "color: teal" }, form.REPORT_NUMBER)]));
    message.push(h("p", null, [h("span", null, "备案编号："), h("span", { style: "color: teal" }, form.RECORD_NUMBER)]));
  }
  message.push(h("p", null, [h("span", null, "是否报送省公共服务平台："), h("span", { style: "color: teal" }, form.select_IS_REPORT_PROVINCE)]));
  if (/^x[0-9]{5,6}$/.test(form.regionId)) {
    call && call();
  } else {
    ElMessageBox.confirm(h("div", null, message), "提示", {
      type: "warning",
    }).then((action) => {
      call && call();
    }).catch((e) => null);
  }
};

const commitOrNot = ($store, commitAction, form, call) => {
  if (commitAction) {
    if (__type__ == "water") {
      doCommitWater($store, commitAction, form, call);
    } else {
      doCommit($store, commitAction, form, call);
    }
  } else {
    call();
  }
};

const getFileToken = (raw) => {
  return api.get("/File/QNToken", { md5: raw.md5 });
};

const reSetParams = () => {
  state.params = getUrlParams();
};

export default {
  getOpenSignConfig,
  getTenderProject,
  getActions,
  getNextActions,
  getPublicActions,
  getRecords,
  getDataExchange,
  setEntpBaseInfo,
  getAlipayAccounts,
  getSections,
  getRegSectionDetail,
  getBaOrBjData,
  doSwitch,
  doCommit,
  doCommitWater,
  getFileToken,
  reSetParams,
  getAreaTree,
  getBankList,
  getBookingOptions,
};
